import { Icon } from "@iconify/react";
import { Delete } from "../api/api";
import { Menu } from "@szhsin/react-menu";
import { MenuItem } from "@szhsin/react-menu";
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import toast from "react-hot-toast";
import { useState } from "react";
import { ProductEditor } from "./ProductEditor";
import { useConfirmDialog } from "@/hooks/useConfirmDialog";

export function Product({ product, addToCart, refetch }) {
  const [edit, setEdit] = useState(false);
  // Si la URL de la foto está rota se cae al icono en vez de dejar el hueco vacío.
  const [imageError, setImageError] = useState(false);
  const confirm = useConfirmDialog();

  const onDelete = async () => {
    confirm({
      title: 'Eliminar producto',
      description: '¿Estas seguro de que quieres eliminar este producto?',
      okText: 'Eliminar',
      variant: 'danger',
      onOk: async () => {
        let t = toast.loading("Eliminando producto...");
        await Delete({
          request: "/products/" + product.id + '?shop_id=' + localStorage.getItem('shop_id'),
        });
        toast.success("Producto eliminado", { id: t });
        refetch?.();
      }
    });
  };

  return (
    <>
      {edit && (
        <ProductEditor product={product} refetch={refetch} open setOpen={setEdit} />
      )}
      <article className="group relative w-full select-none">
        <button
          type="button"
          onClick={() => addToCart(product)}
          aria-label={`Añadir ${product.name} al carrito`}
          className="flex min-h-48 w-full touch-manipulation flex-col overflow-hidden rounded-xl border border-neutral-200 bg-white text-left shadow-sm outline-none transition-all duration-200 hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-md focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500/40 active:scale-[0.98] active:bg-blue-50/40"
        >
          <div
            className="flex h-28 w-full shrink-0 items-center justify-center overflow-hidden border-b border-neutral-100"
            style={{ backgroundColor: product.color || "#f5f5f5" }}
          >
            {product?.image && !imageError ? (
              /* <img> y no LazyLoadImage: la librería envuelve la foto en un
                 <span> con display:inline-block en línea, así que h-full no
                 resuelve y la imagen sale a su tamaño natural, recortada. */
              <img
                src={product.image}
                alt={product.name}
                loading="lazy"
                decoding="async"
                onError={() => setImageError(true)}
                className="h-full w-full animate-fade object-cover"
              />
            ) : (
              <Icon icon="mdi:food-outline" className="text-5xl text-neutral-400" />
            )}
          </div>
          <div className="flex min-h-20 flex-1 items-end gap-2 p-3">
            <div className="min-w-0 flex-1 pr-8">
              <div className="line-clamp-2 min-h-10 text-sm font-semibold leading-5 text-neutral-800">
                {product.name}
              </div>
              <div className="mt-1.5 text-base font-bold text-neutral-900">
                {product.price.toFixed(2)}€
              </div>
            </div>
          </div>
        </button>

        {/* El "+" cuelga de la esquina inferior derecha. Es decorativo: el toque
            cae en el botón de la tarjeta, así que va con pointer-events-none
            para no interceptar el toque del producto de al lado. El hueco de la
            esquina derecha de la tarjeta es de 20px, y el badge sobresale 10px. */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -bottom-2.5 -right-2.5 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 text-white shadow-md ring-4 ring-white transition-all duration-200 group-hover:scale-105 group-hover:bg-blue-700"
        >
          <Icon icon="mdi:plus" className="text-2xl" />
        </span>

        <div className="absolute right-2 top-2 z-20">
          <Menu
            menuButton={
              <button
                type="button"
                aria-label={`Opciones de ${product.name}`}
                className="flex h-11 w-11 touch-manipulation items-center justify-center rounded-xl border border-neutral-200 bg-white/95 text-neutral-600 shadow-sm backdrop-blur-sm transition-colors hover:bg-neutral-100 hover:text-neutral-900 active:scale-95"
              >
                <Icon icon="mdi:dots-vertical" className="text-xl" />
              </button>
            }
            transition
          >
            <MenuItem onClick={() => setEdit(true)}>Editar</MenuItem>
            <MenuItem onClick={onDelete} className="text-red-500">Eliminar</MenuItem>
          </Menu>
        </div>
      </article>
    </>
  );
}
